<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 155px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showStartDate == '' && showEndDate == '') || (showStartDate != '' && showEndDate != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showStartDate != '' && showEndDate != '' && isShowDate == true
      }"
      :style="navbarWithName ? 'margin-left: 10px !important;' : ''"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0 mb-2" cols="12" sm="2">
        <v-select
          :items="topicSentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          no-data-text="No topic available"
          dense
          outlined
          rounded
          @change="parameterProsesTopic"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topicKeywordSentiment"
          v-model="selectedKeyword"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          no-data-text="No keyword available"
          dense
          outlined
          rounded
          @change="parameterProsesKeyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeBerita"
          item-text="name"
          item-value="value"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameterProsesPeriode"
        ></v-select>
      </v-col>

      <v-col
        v-if="showStartDate != '' && showEndDate != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showStartDate[1] + " " + showStartDate[0] + " " + showStartDate[2] }} - {{ showEndDate[1] + " " + showEndDate[0] + " " + showEndDate[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showStartDate == '' && showEndDate == '') || (showStartDate != '' && showEndDate != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showStartDate != '' && showEndDate != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="loadEmotion()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          style="max-width: 100%;"
          height="40"
          color="#a80202"
          variant="outlined"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg12>
        <v-card class="mx-5 pa-4 rounded-lg" height="auto" flat>
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <div
                style="
                  width: 55px;
                  height: 55px;
                  background: #2B4A6F;
                  border-radius: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 12px;
                "
              >
                <v-icon color="white" size="35">
                  mdi-trending-up
                </v-icon>
              </div>
              <div>
                <div class="text-h6 font-weight-bold">
                  Emotion Trends Over Time
                </div>
                <div class="text-body-2 grey--text">
                  Emotional sentiment distribution
                </div>
              </div>
            </div>

            <div class="d-flex align-center">
              <div class="d-flex align-center" style="gap: 0;">
                <v-btn
                  :class="viewMode == 'emotions' ? 'active-btn' : 'inactive-btn'"
                  style="text-transform: none; font-weight: 500; border-radius: 8px; min-width: 160px;"
                  height="40"
                  depressed
                  @click="viewMode = 'emotions', selectedDataInclusion = ['All'], generateEmotionsData()"
                >
                  Emotions per Source
                </v-btn>
                <v-btn
                  :class="viewMode == 'sources' ? 'ml-3 active-btn' : 'ml-3 inactive-btn'"
                  style="text-transform: none; font-weight: 500; border-radius: 8px; min-width: 160px;"
                  height="40"
                  depressed
                  @click="viewMode = 'sources', selectedDataInclusion = ['All'], generateSourcesData()"
                >
                  Sources per Emotion
                </v-btn>
              </div>
              <v-select
                :items="dataInclusionItems"
                v-model="selectedDataInclusion"
                class="mt-6 ml-3 elevation-0 shadow-0 no-bold-selection"
                style="width: 200px;"
                color="#0471A5"
                item-color="#0471A5"
                label="Data Inclusion"
                multiple
                dense
                outlined
                rounded
                @change="handleMultipleDataInclusion"
              ></v-select>
            </div>
          </v-card-title>

          <v-card-text>
            <apexchart
              type="line"
              height="400"
              :options="currentChartOptions"
              :series="currentSeries"
            ></apexchart>

            <v-divider class="mt-2 mb-5"></v-divider>
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="text-subtitle-1 font-weight-medium">
                {{ totalTitle }}
              </div>
              <div class="text-caption grey--text">
                (Sum of all data points)
              </div>
            </div>

            <v-row class="mb-3" dense>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-for="(item, index) in currentTotals.slice(0, 4)"
                :key="index"
              >
                <v-card class="pa-4 rounded-lg" outlined>
                  <div class="d-flex align-center mb-2">
                    <v-icon class="mr-2" :color="item.color" small>
                      mdi-circle
                    </v-icon>
                    <span class="text-body-2 grey--text text--darken-1">
                      {{ item.name }}
                    </span>
                  </div>
                  <div class="d-flex align-center">
                    <span class="text-h5 font-weight-bold" :style="{ color: item.color }">
                      {{ item.total }}
                    </span>
                    <span class="ml-2 grey--text text--darken-1 text-subtitle-2">
                      ({{ totalCurrentValue ? Math.round((item.total / totalCurrentValue) * 100) : 0 }}%)
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="currentTotals.length > 4" dense>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-for="(item, index) in currentTotals.slice(4)"
                :key="index + 4"
              >
                <v-card class="pa-4 rounded-lg" outlined>
                  <div class="d-flex align-center mb-2">
                    <v-icon class="mr-2" :color="item.color" small>
                      mdi-circle
                    </v-icon>
                    <span class="text-body-2 grey--text text--darken-1">
                      {{ item.name }}
                    </span>
                  </div>
                  <div class="d-flex align-center">
                    <span class="text-h5 font-weight-bold" :style="{ color: item.color }">
                      {{ item.total }}
                    </span>
                    <span class="ml-2 grey--text text--darken-1 text-subtitle-2">
                      ({{ totalCurrentValue ? Math.round((item.total / totalCurrentValue) * 100) : 0 }}%)
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg5>
        <v-card class="mx-5 my-6 pa-3 rounded-lg" height="auto" flat>
          <v-card-title class="d-flex align-center justify-space-between" style="padding: 16px 4px;">
            <div class="d-flex align-center" style="flex: 1; min-width: 0;">
              <div
                style="
                  flex-shrink: 0;
                  height: 55px;
                  width: 55px;
                  background: #2B4A6F;
                  border-radius: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  align-self: flex-start;
                  margin-top: 8px;
                  margin-right: 12px;
                  margin-left: 10px;
                "
              >
                <v-icon color="white" size="35">
                  mdi-cloud-outline
                </v-icon>
              </div>
              <div style="flex: 1; min-width: 0; display: flex; gap: 6px;">
                <div style="flex: 5; min-width: 0;">
                  <div class="text-h6 font-weight-bold">
                    Emotion-Based Keywords
                  </div>
                  <div class="text-body-2 grey--text">
                    Most frequent terms <br> across social media
                  </div>
                </div>

                <div style="flex: 7; min-width: 0;">
                  <div class="mt-1 grey--text text-caption" style="font-size: 13px !important;">
                    This analysis has been calculated on {{ lastCalculatedOn }}
                  </div>

                  <div class="mt-2 d-flex flex-wrap" style="gap: 8px;">
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #FFD700; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Joy
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #1E88E5; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Trust
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #6A1B9A; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Fear
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #FB8C00; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Surprise
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #546E7A; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Sadness
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #7CB342; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Disgust
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #E53935; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Anger
                      </span>
                    </div>
                    <div class="d-flex align-center" style="gap: 4px;">
                      <div style="width: 12px; height: 12px; background: #00897B; border-radius: 50%;"></div>
                      <span class="text-caption">
                        Anticipation
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-title>

          <div class="ml-4 d-flex justify-space-between align-center">
            <div class="text-h6 font-weight-bold" style="color: #2B4A6F;">
              <span v-if="viewTagCloudContextualTfIdf == 'contextual'">
                Contextual
              </span>
              <span v-if="viewTagCloudContextualTfIdf == 'tf-idf'">
                TF-IDF
              </span>
            </div>

            <div v-if="viewTagCloudContextualTfIdf == 'contextual'" class="d-flex align-center" style="gap: 10px;">
              <v-btn
                :class="viewTagCloudAdjectiveVerb == 'adjective' ? 'active-btn' : 'inactive-btn'"
                style="text-transform: none; font-weight: 500; border-radius: 8px; min-width: 100px;"
                height="40"
                depressed
                @click="viewTagCloudAdjectiveVerb = 'adjective', generateTagCloudAdjective()"
              >
                Adjective
              </v-btn>

              <v-btn
                :class="viewTagCloudAdjectiveVerb == 'verb' ? 'active-btn' : 'inactive-btn'"
                style="text-transform: none; font-weight: 500; border-radius: 8px; min-width: 100px;"
                height="40"
                depressed
                @click="viewTagCloudAdjectiveVerb = 'verb', generateTagCloudVerb()"
              >
                Verb
              </v-btn>
            </div>
          </div>

          <v-card-text style="padding: 0;">
            <div
              ref="cloudContainer"
              style="
                height: auto;
                width: 100%;
                display: block;
                position: relative;
                overflow: hidden;
                align-self: stretch;
              "
            >
              <div
                :style="{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: groupedEmotionTags.length == 0 ? '325px' : 'auto',
                }"
              >
                <v-icon
                  class="ml-5 chevron-left"
                  :style="{
                    position: 'absolute',
                    left: '-15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: viewTagCloudContextualTfIdf == 'contextual' ? 'default' : 'pointer',
                    color: viewTagCloudContextualTfIdf == 'contextual' ? '#ccc' : '#2B4A6F',
                    zIndex: 10
                  }"
                  size="36"
                  @click="generateTagCloudContextual()"
                >
                  mdi-chevron-left
                </v-icon>

                <div style="flex: 1; overflow: hidden;">
                  <div
                    v-for="(row, rowIndex) in groupedEmotionTags"
                    :key="rowIndex"
                    :style="{
                      textAlign: 'center',
                      marginTop: rowIndex == 0 ? '30px' : '0px',
                      marginBottom: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '15px'
                    }"
                  >
                    <span
                      v-for="(item, index) in row"
                      :key="index"
                      :style="{
                        fontSize: item.font + 'px',
                        color: item.color,
                        fontWeight: 500,
                        fontFamily: 'Roboto, sans-serif',
                        cursor: 'default'
                      }"
                      @mousemove="showTagCloudTooltip($event, item)"
                      @mouseleave="hideTagCloudTooltip"
                    >
                      {{ item.text }}
                    </span>
                  </div>
                </div>

                <v-icon
                  class="mr-5 chevron-right"
                  :style="{
                    position: 'absolute',
                    right: '-15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: viewTagCloudContextualTfIdf == 'tf-idf' ? 'default' : 'pointer',
                    color: viewTagCloudContextualTfIdf == 'tf-idf' ? '#ccc' : '#2B4A6F',
                    zIndex: 10
                  }"
                  size="36"
                  @click="generateTagCloudTfIdf()"
                >
                  mdi-chevron-right
                </v-icon>
              </div>
            </div>
          </v-card-text>

          <div
            v-if="tooltipTagCloud.visible"
            :style="{
              top: tooltipTagCloud.top + 'px',
              left: tooltipTagCloud.left + 'px'
            }"
            class="tooltip-tagcloud"
          >
            <b style="font-size: 18px;">
              {{ tooltipTagCloud.data.text }}
            </b>
            <div class="tooltip-row" style="margin-top: 2px;">
              <span class="tooltip-label">
                Value:
              </span>
              <span class="tooltip-value">
                {{ tooltipTagCloud.data.value }} <span style="position: relative; top: -2px; display: inline-block;">({{ totalTagCloudValue ? parseFloat(((tooltipTagCloud.data.value / totalTagCloudValue) * 100).toFixed(2)) : 0 }}%)</span>
              </span>
            </div>
            <div class="tooltip-row">
              <span class="tooltip-label">
                Emotion:
              </span>
              <span class="tooltip-value">
                {{ tooltipTagCloud.data.emotion }}
              </span>
            </div>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg7>
        <v-card class="mx-5 my-6 pa-4 rounded-lg" height="auto" flat>
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <div
                style="
                  width: 55px;
                  height: 55px;
                  background: #2B4A6F;
                  border-radius: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 12px;
                "
              >
                <v-icon color="white" size="35">
                  mdi-apps
                </v-icon>
              </div>
              <div>
                <div class="text-h6 font-weight-bold">
                  Emotion–Entity Heatmap
                </div>
                <div class="text-body-2 grey--text">
                  Emotional associations with persons and organizations
                </div>
              </div>
            </div>
          </v-card-title>

          <v-card-text>
            <div style="overflow-x: auto;">
              <div style="display: flex; margin-bottom: 8px; padding-left: 60px;">
                <div
                  v-for="emotion in emotionsHeatmap" :key="emotion"
                  style="flex: 1; min-width: 40px; text-align: center; font-size: 12px; color: #666; font-weight: 500;"
                >
                  {{ emotion }}
                </div>
              </div>

              <div
                v-for="(entity, index) in entitiesHeatmap" :key="index"
                style="display: flex; align-items: center; margin-left: 5px; margin-bottom: 6px;"
              >
                <div
                  style="width: 50px; min-width: 50px; height: 40px; display: flex; align-items: center; justify-content: center; margin-right: 10px; position: relative;"
                  @mouseenter="showTooltipAvatar($event, entity.name)"
                  @mouseleave="hideTooltipAvatar()"
                >
                  <img
                    :src="entity.avatar"
                    style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain; cursor: default;"
                  />
                  <div
                    v-if="tooltipAvatar.show && tooltipAvatar.name == entity.name"
                    style="position: absolute; width: 45px; height: 45px; border-radius: 50%; border: 5px solid #2B4A6F; pointer-events: none;"
                  ></div>
                </div>

                <div
                  v-for="(value, emotionIndex) in entity.strengthValues" :key="emotionIndex"
                  :style="{
                    flex: '1',
                    minWidth: '50px',
                    height: '40px',
                    margin: '0 2px',
                    borderRadius: '8px',
                    backgroundColor: getHeatmapColor(value),
                    transition: 'all 0.3s ease',
                    cursor: 'default'
                  }"
                  @mouseenter="showTooltipHeatmap($event, entity.name, emotionsHeatmap[emotionIndex], value, entity.values[emotionIndex])"
                  @mouseleave="hideTooltipHeatmap()"
                ></div>
              </div>

              <div
                v-if="tooltipHeatmap.show"
                :style="{
                  position: 'fixed',
                  left: tooltipHeatmap.x + 'px',
                  top: tooltipHeatmap.y + 'px',
                  backgroundColor: '#2B4A6F',
                  color: 'white',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  fontSize: '13px',
                  fontWeight: '500',
                  zIndex: 1000,
                  pointerEvents: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  whiteSpace: 'nowrap',
                  transform: 'translate(-50%, -100%)',
                  marginTop: '-10px'
                }"
              >
                <div style="font-size: 14px; font-weight: 600; margin-bottom: 2px;">
                  {{ tooltipHeatmap.entity }}
                </div>
                <div style="font-size: 12px; opacity: 0.9;">
                  {{ tooltipHeatmap.emotion }}
                </div>
                <div style="font-size: 12px; opacity: 0.9;">
                  Strength: {{ tooltipHeatmap.strengthValue }}
                </div>
                <div style="font-size: 12px; opacity: 0.9;">
                  Value: {{ tooltipHeatmap.value }}
                </div>
                <div
                  :style="{
                    position: 'absolute',
                    bottom: '-6px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderTop: '6px solid #2B4A6F'
                  }"
                ></div>
              </div>

              <div
                v-if="tooltipAvatar.show"
                :style="{
                  position: 'fixed',
                  left: tooltipAvatar.x + 'px',
                  top: tooltipAvatar.y + 'px',
                  backgroundColor: '#1E293B',
                  color: 'white',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  zIndex: 1000,
                  pointerEvents: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  whiteSpace: 'nowrap',
                  transform: 'translateY(-50%)',
                  marginLeft: '10px'
                }"
              >
                {{ tooltipAvatar.name }}
              </div>

              <div style="display: flex; align-items: center; margin-top: 20px; padding-left: 60px;">
                <span style="font-size: 12px; color: #666; margin-right: 10px; font-weight: 500;">
                  Intensity:
                </span>
                <span style="font-size: 11px; color: #999; margin-right: 8px;">
                  Low
                </span>
                <div
                  v-for="intensity in [1, 2, 3, 4, 5]" :key="intensity"
                  :style="{
                    width: '30px',
                    height: '16px',
                    backgroundColor: getHeatmapColor(intensity),
                    borderRadius: '4px',
                    margin: '0 2px'
                  }"
                ></div>
                <span style="font-size: 11px; color: #999; margin-left: 8px;">
                  High
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              Loading content, please wait
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogSearchContext" height="500" width="350">
        <v-card class="pa-5" color="var(--color-theme-secondary)" rounded="lg" dark>
          <v-btn class="btn-close-dialog-search-context" icon @click="dialogSearchContext = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text
            class="text-center"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;"
          >
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ searchContextTopic }}</strong> <br>
              From: <strong>{{ searchContextStartDate }}</strong> to <strong>{{ searchContextEndDate }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="dialogConfirmReset = false"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import Notification from '@/components/Notification';
import { mapGetters } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import { decryptionData, generateFilterDate, processTopicKeywords, encodeKeywordRequest, trackEvent } from '@/components/utils/utils.js';

export default {
  components: {
    Notification: Notification,
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      sources: "",
      emotions: ['All', 'Joy', 'Trust', 'Fear', 'Surprise', 'Sadness', 'Disgust', 'Anger', 'Anticipation'],
      selectedDataInclusion: ['All'],
      viewMode: 'emotions',
      emotionsData: {
        series: [],
        colors: [],
        totals: []
      },
      emotionsDataAll: "",
      emotionColorMap: {
        'Joy': '#FFD700',
        'Trust': '#1E88E5',
        'Anticipation': '#00897B',
        'Surprise': '#FB8C00',
        'Sadness': '#546E7A',
        'Fear': '#6A1B9A',
        'Anger': '#E53935',
        'Disgust': '#7CB342'
      },
      emotionCategories: [],
      sourcesData: {
        series: [],
        colors: [],
        totals: []
      },
      sourceColorMap: {
        'Twitter': '#06B6D4',
        'Youtube': '#FF0000',
        'Tik Tok': '#000000',
        'Instagram': '#EC4899'
      },
      containerWidth: 500,
      resizeObserver: null,
      lastCalculatedOn: '-',
      viewTagCloudContextualTfIdf: "contextual",
      viewTagCloudAdjectiveVerb: "adjective",
      emotionTagCloudsContextual: [],
      filteredTagCloudData: [],
      emotionTagCloudsTfIdf: [],
      tooltipTagCloud: {
        visible: false,
        top: 0,
        left: 0,
        data: {}
      },
      emotionsHeatmap: ['Joy', 'Trust', 'Fear', 'Surprise', 'Sadness', 'Disgust', 'Anger', 'Anticipation'],
      entitiesHeatmap: "",
      tooltipHeatmap: {
        show: false,
        x: 0,
        y: 0,
        entity: '',
        emotion: '',
        strengthValue: '',
        value: 0
      },
      tooltipAvatar: {
        show: false,
        x: 0,
        y: 0,
        name: ''
      },
      overlayDialogLoading: false,
      dialogLoading: false,
      dialogSearchContext: false,
      searchContextTopic: "",
      searchContextStartDate: "",
      searchContextEndDate: "",
      alert: false,
      colorAlert: "",
      message: "",
      dialogConfirmReset: false,
      selectedTopic: "",
      selectedKeyword: "",
      selectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      menu: false,
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isShowDate: false,
      showStartDate: "",
      showEndDate: "",
      listIdSourceCollection: "",
      nerPersonSearch: "",
      nerOrganizationSearch: "",
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    },
    dataInclusionItems() {
      return this.viewMode == 'emotions' ? this.sources : this.emotions;
    },
    currentSeries() {
      return this.viewMode == 'emotions'
        ? this.emotionsData.series
        : this.sourcesData.series
    },
    currentChartOptions() {
      const baseOptions = {
        chart: {
          type: 'line',
          toolbar: { show: false }
        },
        colors: this.viewMode == 'emotions'
          ? this.emotionsData.colors
          : this.sourcesData.colors,
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          size: 4
        },
        xaxis: {
          categories: this.emotionCategories || []
        },
        legend: {
          position: 'bottom',
          markers: {
            radius: 12
          }
        },
        grid: {
          borderColor: '#f0f0f0',
          xaxis: {
            lines: { show: false }
          }
        }
      }
      return baseOptions
    },
    currentTotals() {
      return this.viewMode == 'emotions'
        ? this.emotionsData.totals
        : this.sourcesData.totals
    },
    totalTitle() {
      return this.viewMode == 'emotions'
        ? 'Total by Emotion'
        : 'Total by Source'
    },
    groupedEmotionTags() {
      return this.groupEmotionTags(this.filteredTagCloudData);
    },
    totalCurrentValue() {
      return this.currentTotals.reduce((sum, item) => sum + (item.total || 0), 0);
    },
    totalTagCloudValue() {
      return this.filteredTagCloudData.reduce((sum, row) => {
        return sum + (row[0]?.value || 0);
      }, 0);
    }
  },
  mounted() {
    this.loadTopic();
    this.$nextTick(() => {
      if (this.$refs.cloudContainer) {
        this.resizeObserver = new ResizeObserver(() => {
          const newWidth = this.$refs.cloudContainer.clientWidth;
          if (newWidth != this.containerWidth) {
            this.containerWidth = newWidth;
            this.refreshTagCloud();
          }
        });
        this.resizeObserver.observe(this.$refs.cloudContainer);
        this.containerWidth = this.$refs.cloudContainer.clientWidth;
      }
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    async loadEmotion() {
      this.alert = false;
      this.colorAlert = "";
      this.message = "";
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      trackEvent('emotion', {
        topic: this.searchContextTopic,
        keyword: this.selectedKeyword,
        period: this.selectedPeriode
      });

      try {
        await Promise.all([
          this.loadEmotionGrafik(),
          this.loadEmotionTagCloud(),
          this.loadEmotionHeatmap()
        ]);

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.openDialogSearchContext();
      } catch (e) {
        console.error(e);
      }
    },
    async loadEmotionGrafik() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) throw new Error("Auth token not found");

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        let selectedSourceIds = this.listIdSourceCollection
          .filter(id => id != 1)
          .join(',');

        const response = await axios.post(
          `emotion-data?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&source=${selectedSourceIds}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}`,
          {},
          { headers: { 'auth-token': authToken } }
        );

        const emotionData = response.data.data;

        const twitterData = emotionData.date_twitter?.data || [];
        const youtubeData = emotionData.date_youtube?.data || [];
        const tiktokData = emotionData.date_tiktok?.data || [];
        const instagramData = emotionData.date_instagram?.data || [];

        const allDates = new Set();
        twitterData.forEach(item => allDates.add(item.date));
        youtubeData.forEach(item => allDates.add(item.date));
        tiktokData.forEach(item => allDates.add(item.date));
        instagramData.forEach(item => allDates.add(item.date));

        const sortedDates = Array.from(allDates).sort();
        this.emotionCategories = sortedDates.map(date => {
          const d = new Date(date);
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const year = d.getFullYear();
          return `${day}-${month}-${year}`;
        });

        const emotionKeys = ["joy", "trust", "fear", "surprise", "sadness", "disgust", "anger", "anticipation"];

        const emotionsWithTotals = emotionKeys.map(emotion => {
          const twitterMap = {};
          const youtubeMap = {};
          const tiktokMap = {};
          const instagramMap = {};

          twitterData.forEach(item => { twitterMap[item.date] = item[emotion] || 0; });
          youtubeData.forEach(item => { youtubeMap[item.date] = item[emotion] || 0; });
          tiktokData.forEach(item => { tiktokMap[item.date] = item[emotion] || 0; });
          instagramData.forEach(item => { instagramMap[item.date] = item[emotion] || 0; });

          const twitterValues = sortedDates.map(date => twitterMap[date] || 0);
          const youtubeValues = sortedDates.map(date => youtubeMap[date] || 0);
          const tiktokValues = sortedDates.map(date => tiktokMap[date] || 0);
          const instagramValues = sortedDates.map(date => instagramMap[date] || 0);

          const twitterTotal = twitterValues.reduce((sum, val) => sum + val, 0);
          const youtubeTotal = youtubeValues.reduce((sum, val) => sum + val, 0);
          const tiktokTotal = tiktokValues.reduce((sum, val) => sum + val, 0);
          const instagramTotal = instagramValues.reduce((sum, val) => sum + val, 0);

          const total = twitterTotal + youtubeTotal + tiktokTotal + instagramTotal;

          const combinedData = sortedDates.map((date, i) =>
            twitterValues[i] + youtubeValues[i] + tiktokValues[i] + instagramValues[i]
          );

          return {
            emotion,
            total,
            data: combinedData,
            sourceData: {
              "Twitter": twitterValues,
              "Youtube": youtubeValues,
              "Tik Tok": tiktokValues,
              "Instagram": instagramValues
            }
          };
        });

        emotionsWithTotals.sort((a, b) => b.total - a.total);

        this.emotionsData.series = emotionsWithTotals.map(item => {
          const emotionName = item.emotion.charAt(0).toUpperCase() + item.emotion.slice(1);
          return {
            name: emotionName,
            data: item.data,
            color: this.emotionColorMap[emotionName],
            sourceData: item.sourceData
          };
        });

        this.emotionsData.totals = emotionsWithTotals.map(item => {
          const emotionName = item.emotion.charAt(0).toUpperCase() + item.emotion.slice(1);
          return {
            name: emotionName,
            total: item.total,
            color: this.emotionColorMap[emotionName]
          };
        });

        this.emotionsData.colors = emotionsWithTotals.map(item => {
          const emotionName = item.emotion.charAt(0).toUpperCase() + item.emotion.slice(1);
          return this.emotionColorMap[emotionName];
        });

        this.emotionsDataAll = JSON.parse(JSON.stringify(this.emotionsData));

        if (this.viewMode == "sources") {
          this.generateSourcesData();
        }

        window.dispatchEvent(new Event("resize"));
      } catch (e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Emotion Data Response Data Not Found";
        this.colorAlert = "red";
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    generateEmotionsData() {
      trackEvent('emotion-per-emotion', { topic: this.searchContextTopic });

      const selectedSources = this.selectedDataInclusion.includes('All')
        ? this.sources.filter(s => s != 'All')
        : this.selectedDataInclusion;

      const filteredSeries = this.emotionsDataAll.series.map(emotion => {
        const filteredData = emotion.data.map((totalValue, index) => {
          if (this.selectedDataInclusion.includes('All')) {
            return totalValue;
          }

          let sum = 0;
          selectedSources.forEach(source => {
            if (emotion.sourceData && emotion.sourceData[source] && emotion.sourceData[source][index]) {
              sum += emotion.sourceData[source][index];
            }
          });
          return sum;
        });

        return {
          name: emotion.name,
          data: filteredData,
          color: emotion.color,
          sourceData: emotion.sourceData
        };
      });

      const filteredTotals = filteredSeries.map(emotion => {
        const total = emotion.data.reduce((sum, val) => sum + val, 0);

        return {
          name: emotion.name,
          total: total,
          color: emotion.color
        };
      });

      filteredTotals.sort((a, b) => b.total - a.total);

      const sortedSeries = filteredTotals.map(totalItem => {
        return filteredSeries.find(series => series.name == totalItem.name);
      });

      this.emotionsData = {
        series: sortedSeries,
        colors: sortedSeries.map(s => s.color),
        totals: filteredTotals
      };

      window.dispatchEvent(new Event("resize"));
    },
    generateSourcesData() {
      trackEvent('emotion-per-source', { topic: this.searchContextTopic });

      const allSources = ["Twitter", "Youtube", "Tik Tok", "Instagram"];

      const selectedEmotions = this.selectedDataInclusion.includes('All')
        ? this.emotions.filter(e => e != 'All')
        : this.selectedDataInclusion;

      const filteredSeries = allSources.map(sourceName => {
        const sourceValues = [];
        const totalDates = this.emotionsDataAll.series[0].data.length;
        for (let index = 0; index < totalDates; index++) {
          let sum = 0;
          this.emotionsDataAll.series.forEach(em => {
            if (selectedEmotions.includes(em.name)) {
              const srcArr = em.sourceData[sourceName] || [];
              sum += srcArr[index] || 0;
            }
          });
          sourceValues.push(sum);
        }

        return {
          name: sourceName,
          data: sourceValues,
          color: this.sourceColorMap[sourceName]
        };
      });

      const filteredTotals = filteredSeries.map(source => {
        const total = source.data.reduce((sum, val) => sum + val, 0);
        return {
          name: source.name,
          total: total,
          color: this.sourceColorMap[source.name]
        };
      });

      filteredTotals.sort((a, b) => b.total - a.total);

      const sortedSeries = filteredTotals.map(t => {
        return filteredSeries.find(s => s.name == t.name);
      });

      this.sourcesData = {
        series: sortedSeries,
        colors: sortedSeries.map(s => s.color),
        totals: filteredTotals
      };

      window.dispatchEvent(new Event("resize"));
    },
    calculateTotal(dataArray) {
      return dataArray.reduce((sum, value) => sum + value, 0);
    },
    handleMultipleDataInclusion(newVal) {
      const all = 'All';

      if (newVal.includes(all)) {
        if (newVal.length > 1) {
          this.selectedDataInclusion = newVal.filter(k => k != all);
        }
        if (newVal.length > 1 && newVal[newVal.length - 1] == "All") {
          this.selectedDataInclusion = [all];
        }
      }
      else {
        this.selectedDataInclusion = newVal;
      }

      if (this.viewMode == 'emotions') {
        this.generateEmotionsData();
      } else if (this.viewMode == 'sources') {
        this.generateSourcesData();
      }
    },
    async loadEmotionTagCloud() {
      this.loadDataSendTopicLatest();

      for (let i = 0; i < this.topicSentiment.length; i++) {
        if (this.topicSentiment[i].SEQ_ID == this.$store.topic_glob) {
          this.searchContextTopic = this.topicSentiment[i].TOPIC;
        }
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

        const response = await axios.post(
          "/analysis-generate-json",
          {
            api_type: "emotion",
            topic: this.searchContextTopic,
            period: periode,
            sentiment: "All",
          },
          {
            headers: {
              "auth-token": authToken,
            },
          }
        );

        const contextualData = response.data.data.tag_cloud_emotion.Contextual;
        const tfIdfData = response.data.data.tag_cloud_emotion["TF-IDF"];

        const contextualByEmotion = {};
        const tfIdfByEmotion = {};

        this.emotions.forEach(emotion => {
          if (emotion != 'All') {
            contextualByEmotion[emotion] = [];
            tfIdfByEmotion[emotion] = [];
          }
        });

        this.emotionTagCloudsContextual = [];
        this.emotionTagCloudsTfIdf = [];

        Object.keys(contextualData).forEach(emotionKey => {
          const emotion = contextualData[emotionKey];
          const emotionName = emotionKey.charAt(0).toUpperCase() + emotionKey.slice(1).toLowerCase();
          const color = this.emotionColorMap[emotionName];

          if (!color) {
            return;
          }

          if (emotion.ADJECTIVE && emotion.ADJECTIVE.keywords) {
            emotion.ADJECTIVE.keywords.forEach(item => {
              contextualByEmotion[emotionName].push([{
                text: item.keyword,
                value: item.count,
                emotion: emotionName,
                font: item.count,
                color: color,
                type: "Adjective"
              }]);
            });
          }

          if (emotion.VERB && emotion.VERB.keywords) {
            emotion.VERB.keywords.forEach(item => {
              contextualByEmotion[emotionName].push([{
                text: item.keyword,
                value: item.count,
                emotion: emotionName,
                font: item.count,
                color: color,
                type: "Verb"
              }]);
            });
          }
        });

        if (tfIdfData && Array.isArray(tfIdfData)) {
          tfIdfData.forEach(emotionData => {
            const emotionName = emotionData.emotion.charAt(0).toUpperCase() +
                              emotionData.emotion.slice(1).toLowerCase();
            const color = this.emotionColorMap[emotionName];

            if (!color) {
              return;
            }

            if (emotionData.keywords && Array.isArray(emotionData.keywords)) {
              emotionData.keywords.forEach(item => {
                tfIdfByEmotion[emotionName].push([{
                  text: item.keyword,
                  value: item.count,
                  emotion: emotionName,
                  font: item.count,
                  color: color,
                  type: "TF-IDF"
                }]);
              });
            }
          });
        }

        this.emotions.forEach(emotion => {
          if (emotion != 'All') {
            if (contextualByEmotion[emotion]) {
              this.emotionTagCloudsContextual.push(...contextualByEmotion[emotion]);
            }
            if (tfIdfByEmotion[emotion]) {
              this.emotionTagCloudsTfIdf.push(...tfIdfByEmotion[emotion]);
            }
          }
        });

        if (this.viewTagCloudContextualTfIdf == 'contextual') {
          if (this.viewTagCloudAdjectiveVerb == 'adjective') {
            this.generateTagCloudAdjective();
          } else if (this.viewTagCloudAdjectiveVerb == 'verb') {
            this.generateTagCloudVerb();
          }
        } else if (this.viewTagCloudContextualTfIdf == 'tf-idf') {
          this.generateTagCloudTfIdf();
        }
      } catch (e) {
        console.log(e);
        this.filteredTagCloudData = [];
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Emotion Tag Cloud Response Data Not Found";
        this.colorAlert = "red";
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    refreshTagCloud() {
      if (this.viewTagCloudContextualTfIdf == 'contextual') {
        if (this.viewTagCloudAdjectiveVerb == 'adjective') {
          this.generateTagCloudAdjective();
        } else {
          this.generateTagCloudVerb();
        }
      } else {
        this.generateTagCloudTfIdf();
      }
    },
    estimateTextWidth(text, fontSize) {
      return text.length * fontSize * 0.58;
    },
    groupEmotionTags(emotionTagCloudsContextual) {
      const chevronSpace = 60;
      const availableWidth = (this.containerWidth || 500) - chevronSpace;

      const grouped = [];
      const minFont = 15;
      const maxFont = 50;
      const gap = 15;

      let minValue = Infinity;
      let maxValue = -Infinity;

      emotionTagCloudsContextual.forEach((row) => {
        if (row.length > 0 && row[0].value) {
          minValue = Math.min(minValue, row[0].value);
          maxValue = Math.max(maxValue, row[0].value);
        }
      });

      const scaleFontSize = (value) => {
        if (maxValue == minValue) return minFont;
        return Math.round(
          minFont + ((value - minValue) / (maxValue - minValue)) * (maxFont - minFont)
        );
      };

      const items = emotionTagCloudsContextual
        .filter(row => row.length > 0)
        .map(row => {
          const item = { ...row[0] };
          item.font = scaleFontSize(item.value);
          return item;
        });

      let currentRow = [];
      let currentRowWidth = 0;

      items.forEach((item) => {
        const wordWidth = this.estimateTextWidth(item.text, item.font);
        const spaceNeeded = currentRow.length > 0 ? gap + wordWidth : wordWidth;

        if (currentRow.length > 0 && currentRowWidth + spaceNeeded > availableWidth) {
          grouped.push([...currentRow]);
          currentRow = [item];
          currentRowWidth = wordWidth;
        } else {
          currentRow.push(item);
          currentRowWidth += spaceNeeded;
        }
      });

      if (currentRow.length > 0) {
        grouped.push(currentRow);
      }

      return grouped;
    },
    generateTagCloudContextual() {
      this.viewTagCloudContextualTfIdf = 'contextual';

      if (this.viewTagCloudAdjectiveVerb == 'adjective') {
        this.generateTagCloudAdjective();
      } else {
        this.generateTagCloudVerb();
      }
    },
    generateTagCloudTfIdf() {
      this.filteredTagCloudData = this.emotionTagCloudsTfIdf;
      this.viewTagCloudContextualTfIdf = 'tf-idf';
    },
    generateTagCloudAdjective() {
      const adjectiveData = this.emotionTagCloudsContextual.filter(row => {
        return row.length > 0 && row[0].type == "Adjective";
      });

      this.filteredTagCloudData = adjectiveData;
    },
    generateTagCloudVerb() {
      const verbData = this.emotionTagCloudsContextual.filter(row => {
        return row.length > 0 && row[0].type == "Verb";
      });

      this.filteredTagCloudData = verbData;
    },
    async loadDataSendTopicLatest() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let periode = this.$store.selectedPeriode_glob.toUpperCase().replace(/ /g, '_');
        const topic = this.$store.topic_glob;

        const endpoints = ['SCHEDULER EMOTION', 'EMOTION'];

        const results = [];

        for (const endpoint of endpoints) {
          const response = await axios.get(
            `data-send-topic-last-calculated?periode=${periode}&topic=${topic}&endpoint=${endpoint}`,
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const result = response?.data?.data?.result;

          if (Array.isArray(result) && result.length > 0 && result[0].CREATED_AT) {
            results.push(result[0]);
          }
        }

        if (results.length > 0) {
          const latest = results.reduce((a, b) => a.SEQ_ID > b.SEQ_ID ? a : b);
          this.lastCalculatedOn = this.formatDateReadable(latest.CREATED_AT);
        } else {
          this.lastCalculatedOn = '-';
        }
      } catch (error) {
        this.lastCalculatedOn = '-';
      }
    },
    formatDateReadable(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('-');

      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr',
        'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ];

      const monthName = monthNames[parseInt(month) - 1];

      return `${day} ${monthName} ${year}, ${timePart}`;
    },
    showTagCloudTooltip(event, item) {
      this.tooltipTagCloud.visible = true;
      this.tooltipTagCloud.top = event.clientY;
      this.tooltipTagCloud.left = event.clientX;
      this.tooltipTagCloud.data = item;

      this.$nextTick(() => {
        const tooltip = document.querySelector('.tooltip-tagcloud');
        if (tooltip) {
          const rect = tooltip.getBoundingClientRect();
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;

          if (rect.right > viewportWidth) {
            this.tooltipTagCloud.left = event.clientX - rect.width - 20;
          }

          if (rect.bottom > viewportHeight) {
            this.tooltipTagCloud.top = event.clientY - rect.height - 20;
          }
        }
      });
    },
    hideTagCloudTooltip() {
      this.tooltipTagCloud.visible = false;
    },
    async loadEmotionHeatmap() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) throw new Error("Auth token not found");

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        let selectedSourceIds = this.listIdSourceCollection
          .filter(id => id != 1)
          .join(',');

        const [emotionResponse, personResponse, organizationResponse] = await Promise.all([
          axios.post(
            `/emotion-data-headmap?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&source=${selectedSourceIds}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}`,
            {},
            { headers: { 'auth-token': authToken } }
          ),
          axios.get(
            "analyzer_person",
            { headers: { 'auth-token': authToken } }
          ),
          axios.get(
            "data_organization",
            { headers: { 'auth-token': authToken } }
          )
        ]);

        if (emotionResponse.data && emotionResponse.data.data) {
          const apiData = emotionResponse.data.data;

          const personLookup = {};
          if (personResponse.data && personResponse.data.token) {
            personResponse.data.token.forEach(person => {
              const personData = {
                displayName: person.USER_DISPLAY_NAME,
                image: person.PRS_IMAGE,
                alias: person.ALIAS_ARR,
                status: person.USER_STATUS
              };

              if (person.ALIAS_ARR) {
                person.ALIAS_ARR.split(",")
                  .map(a => a.trim().toLowerCase())
                  .forEach(alias => {
                    if (alias) personLookup[alias] = personData;
                  });
              }

              if (person.USER_DISPLAY_NAME) {
                personLookup[person.USER_DISPLAY_NAME.toLowerCase()] = personData;
              }
            });
          }

          const organizationLookup = {};
          if (organizationResponse.data && organizationResponse.data.token) {
            organizationResponse.data.token.forEach(organization => {
              const organizationData = {
                displayName: organization.ORG_DISPLAY_NAME,
                image: organization.LINK_ORG_IMAGE,
                alias: organization.ORG_ALIAS
              };

              if (organization.NER_ALIAS) {
                organization.NER_ALIAS.split(",")
                  .map(a => a.trim().toLowerCase())
                  .forEach(alias => {
                    if (alias) organizationLookup[alias] = organizationData;
                  });
              }

              if (organization.ORG_ALIAS) {
                organizationLookup[organization.ORG_ALIAS.toLowerCase()] = organizationData;
              }

              if (organization.ORG_DISPLAY_NAME) {
                organizationLookup[organization.ORG_DISPLAY_NAME.toLowerCase()] = organizationData;
              }
            });
          }

          const emotionOrder = [
            "joy",
            "trust",
            "fear",
            "surprise",
            "sadness",
            "disgust",
            "anger",
            "anticipation"
          ];

          const entityEmotionMap = {};
          const entityKeyMapping = {};

          const processEntities = (dataSource, entityType) => {
            if (!dataSource || !dataSource[entityType]) return;

            const lookup = entityType == 'persons' ? personLookup : organizationLookup;

            dataSource[entityType].forEach(entity => {
              const entityName = entity.name;
              let entityDetails = lookup[entityName.toLowerCase()];

              if (!entityDetails) {
                const entityLower = entityName.toLowerCase();
                const matchedKey = Object.keys(lookup).find(key =>
                  entityLower.includes(key) || key.includes(entityLower)
                );
                if (matchedKey) entityDetails = lookup[matchedKey];
              }

              const normalizedKey = entityDetails ? entityDetails.displayName : entityName;

              if (!entityKeyMapping[normalizedKey]) {
                entityKeyMapping[normalizedKey] = {
                  displayName: entityDetails ? entityDetails.displayName : entityName,
                  image: entityDetails && entityDetails.image ? entityDetails.image : null,
                  originalNames: [entityName],
                  type: entityType
                };
              } else if (!entityKeyMapping[normalizedKey].originalNames.includes(entityName)) {
                entityKeyMapping[normalizedKey].originalNames.push(entityName);
              }

              if (!entityEmotionMap[normalizedKey]) {
                entityEmotionMap[normalizedKey] = {
                  joy: 0,
                  trust: 0,
                  fear: 0,
                  surprise: 0,
                  sadness: 0,
                  disgust: 0,
                  anger: 0,
                  anticipation: 0
                };
              }

              entity.emotion.forEach(emotion => {
                const emotionName = emotion.name.toLowerCase();
                if (entityEmotionMap[normalizedKey][emotionName] !== undefined) {
                  entityEmotionMap[normalizedKey][emotionName] += emotion.count;
                }
              });
            });
          };

          if (apiData.data_twitter) {
            processEntities(apiData.data_twitter, 'persons');
            processEntities(apiData.data_twitter, 'organizations');
          }
          if (apiData.data_tiktok) {
            processEntities(apiData.data_tiktok, 'persons');
            processEntities(apiData.data_tiktok, 'organizations');
          }
          if (apiData.data_instagram) {
            processEntities(apiData.data_instagram, 'persons');
            processEntities(apiData.data_instagram, 'organizations');
          }
          if (apiData.data_youtube) {
            processEntities(apiData.data_youtube, 'persons');
            processEntities(apiData.data_youtube, 'organizations');
          }

          this.entitiesHeatmap = Object.entries(entityEmotionMap).map(
            ([normalizedKey, emotions]) => {
              const values = emotionOrder.map(e => emotions[e]);
              const mappingInfo = entityKeyMapping[normalizedKey];

              const displayName = mappingInfo.displayName;

              const defaultImage = mappingInfo.type == 'persons'
                ? "/default-person.png"
                : "/default-organization.png";

              const avatar = mappingInfo.image && mappingInfo.image.trim() != ""
                ? mappingInfo.image
                : defaultImage;

              return {
                name: displayName,
                avatar: avatar,
                values: values,
                originalNames: mappingInfo.originalNames,
                type: mappingInfo.type
              };
            }
          );

          this.entitiesHeatmap.sort((a, b) => {
            const sumA = a.values.reduce((acc, v) => acc + v, 0);
            const sumB = b.values.reduce((acc, v) => acc + v, 0);
            return sumB - sumA;
          });

          this.entitiesHeatmap = this.entitiesHeatmap.slice(0, 10);

          const maxValue = Math.max(...this.entitiesHeatmap.flatMap(e => e.values));

          this.entitiesHeatmap = this.entitiesHeatmap.map(entity => ({
            ...entity,
            strengthValues: entity.values.map(v => {
              if (v == 0) return 0;
              return Math.ceil((v / maxValue) * 5);
            })
          }));

          this.emotionsHeatmap = emotionOrder.map(
            e => e.charAt(0).toUpperCase() + e.slice(1)
          );
        }
      } catch (error) {
        console.log(error);
        this.alert = true;
        this.message = "API Emotion Data Heatmap Response Data Not Found";
        this.colorAlert = "red";
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    getHeatmapColor(value) {
      const colors = {
        0: '#FFFFFF',
        1: '#E3E9EF',
        2: '#C7D3DF',
        3: '#8FA9C3',
        4: '#5D7C9F',
        5: '#2B4A6F'
      };
      return colors[value] || colors[0];
    },
    showTooltipHeatmap(event, entity, emotion, strengthValue, value) {
      const rect = event.target.getBoundingClientRect();
      this.tooltipHeatmap = {
        show: true,
        x: rect.left + rect.width / 2,
        y: rect.top,
        entity: entity,
        emotion: emotion,
        strengthValue: strengthValue,
        value: value
      };
    },
    hideTooltipHeatmap() {
      this.tooltipHeatmap.show = false;
    },
    showTooltipAvatar(event, name) {
      const rect = event.target.getBoundingClientRect();
      this.tooltipAvatar = {
        show: true,
        x: rect.right,
        y: rect.top + rect.height / 2,
        name: name
      };
    },
    hideTooltipAvatar() {
      this.tooltipAvatar.show = false;
    },
    async loadTopic() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        if (!data || data.length == 0) {
          this.sources = collections
            .map(item => item.NAME_SOCIAL_MEDIA)
            .filter(src => src != "News");
          this.sources.unshift('All');
          this.listIdSourceCollection = collections.map(item => item.ID);
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          return;
        }

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob === undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
            this.searchContextTopic = data[i].TOPIC;
          }
        }

        this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
          text: keyword,
          value: keyword,
          disabled: index != 0,
        }));

        this.isShowDate = this.$store.is_show_date_glob;
        var fromDate = this.startDate;
        var untilDate = this.endDate;

        if (this.$store.jenis_parameter_glob == "custom") {
          fromDate = this.$store.date_start_glob;
          untilDate = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let dateGenerate = generateFilterDate(periode);
          fromDate = dateGenerate.start_date;
          untilDate = dateGenerate.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob === undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: fromDate,
            date_end_glob: untilDate,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.startDate = this.$store.date_start_glob;
          this.endDate = this.$store.date_end_glob;
        }

        this.sources = dataDecryption.collection
          .map(item => item.NAME_SOCIAL_MEDIA)
          .filter(src => src != "News");
        this.sources.unshift('All');

        this.listIdSourceCollection = collections.map(item => item.ID);

        if (data.length > 0) {
          this.loadEmotion();
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }

        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let dateGenerate = generateFilterDate(periode);
        fromDate = dateGenerate.start_date;
        untilDate = dateGenerate.end_date;
        this.startDate = fromDate;
        this.endDate = untilDate;

        this.searchContextStartDate = this.startDate;
        this.searchContextEndDate = this.endDate;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    openDialogSearchContext() {
      this.dialogSearchContext = true;
      setTimeout(() => {
        this.dialogSearchContext = false;
      }, 10000);
    },
    async parameterProsesTopic() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }

      this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
        text: keyword,
        value: keyword,
        disabled: index != 0,
      }));

      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesKeyword() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesPeriode() {
      let fromDate = this.startDate;
      let untilDate = this.endDate;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let dateGenerate = generateFilterDate(periode);
        fromDate = dateGenerate.start_date;
        untilDate = dateGenerate.end_date;
        this.startDate = fromDate;
        this.endDate = untilDate;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });

      this.searchContextStartDate = fromDate;
      this.searchContextEndDate = untilDate;
      this.showPeriodeDate();
    },
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.startDate);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showStartDate = dateString;

      var date3 = new Date(this.endDate);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showEndDate = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.startDate,
        date_end_glob: this.endDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
  }
}
</script>

<style scoped>
.active-btn {
  background: #2B4A6F !important;
  color: white !important;
}
.inactive-btn {
  background: white !important;
  color: #424242 !important;
  border: 1px solid #E0E0E0 !important;
}
.no-bold-selection ::v-deep .v-select__selection-text,
.no-bold-selection ::v-deep .v-select__selection {
  font-weight: 400 !important;
}
.no-bold-selection ::v-deep .v-input__slot .v-select__selections {
  font-weight: 400 !important;
}
.no-bold-selection ::v-deep .v-select__selections,
.no-bold-selection ::v-deep .v-select__selected-item {
  font-weight: 400 !important;
}
.text-caption {
  font-size: 0.75rem;
}
.tooltip-tagcloud {
  position: fixed;
  background: #fff;
  color: #000;
  pointer-events: none;
  font-size: 13px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  transform: translate(10px, 10px);
  padding: 8px 12px;
  z-index: 9999;
}
.btn-close-dialog-search-context {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  margin-left: auto;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}
</style>
